<template>
  <!-- Table Container Card -->
  <b-card id="page-companiesTypes" no-body class="mb-0 p-2">
    <b-card-header class="pl-0 pr-0">
      <b-card-title
        ><h2>{{ $t(label("title")) }}</h2></b-card-title
      >
      <b-button id="tooltip-create" variant="primary" @click="onCreate">
        <feather-icon icon="PlusIcon" class="mr-25" />
        <span class="text-nowrap">{{ $t(label("register")) }}</span>
      </b-button>
      <b-tooltip
        placement="top"
        target="tooltip-create"
        triggers="hover"
        @click="onInfo"
      >
        <strong>
          <feather-icon icon="ExternalLinkIcon" class="mr-25 mt-0" />
          Ver tutorial
        </strong>
        <span> </span>
      </b-tooltip>
    </b-card-header>
    <!-- <Filterss
      :fields="fildsToFilters"
      @filter-applied="applyFilters"
      @filter-reset="resetFilters"
    /> -->
    <!-- Table for larger devices -->
    <b-table
      id="companiesTypes-table"
      responsive
      :head-variant="headVariant"
      :striped="striped"
      :bordered="bordered"
      :borderless="borderless"
      :outlined="outlined"
      :per-page="perPage"
      :busy="loading"
      :items="items"
      :fields="fields"
      class="d-none d-md-table shadow-sm !rounded"
    >
      <!-- A custom formatted header cell for field 'name' -->
      <template #head()="data">
        <span class="text-black">{{
          $t(labelHeader(data.label.toLowerCase()))
        }}</span>
      </template>

      <template #cell(actions)="data">
        <feather-icon
          class="text-success mr-25"
          size="18"
          icon="FileTextIcon"
          @click="onShow(data.item.guid)"
        />

        <feather-icon
          class="text-primary mr-25"
          size="18"
          icon="EditIcon"
          @click="onEdit(data.item.guid)"
        />

        <feather-icon
          class="text-danger"
          size="18"
          icon="Trash2Icon"
          @click="onDelete(data.item.guid)"
        />
      </template>

      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle ml-50"></b-spinner>
          <strong>{{ $t("loading") }}...</strong>
        </div>
      </template>
    </b-table>

    <!-- List for mobile devices -->
    <div id="list-container" class="d-block d-md-none mt-1 list-container">
      <b-list-group>
        <b-list-group-item
          v-for="item in items"
          :key="item.guid"
          class="d-flex flex-column align-items-start border border-primary rounded mb-1"
        >
          <div class="d-flex w-100 justify-content-between m-0 p-0">
            <p style="margin-bottom: 0 !important">
              <strong>
                {{ $t(labelHeader("size")) }} : {{ item.nameSize }}</strong
              >
            </p>

            <b-dropdown
              variant="link"
              no-caret
              class="chart-dropdown"
              toggle-class="p-0"
              right
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="18"
                  class="text-body cursor-pointer"
                />
              </template>
              <b-dropdown-item>
                <div class="d-flex align-items-center justify-content-between">
                  {{ $t("show") }}
                  <feather-icon
                    class="text-success mr-25"
                    size="18"
                    icon="FileTextIcon"
                    @click="onShow(item.guid)"
                  />
                </div>
              </b-dropdown-item>
              <b-dropdown-item>
                <div class="d-flex align-items-center justify-content-between">
                  {{ $t("edit") }}
                  <feather-icon
                    class="text-primary mr-25"
                    size="18"
                    icon="EditIcon"
                    @click="onEdit(item.guid)"
                  />
                </div>
              </b-dropdown-item>
              <b-dropdown-item>
                <div class="d-flex align-items-center justify-content-between">
                  {{ $t("delete") }}
                  <feather-icon
                    class="text-danger"
                    size="18"
                    icon="Trash2Icon"
                    @click="onDelete(item.guid)"
                  />
                </div>
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <!-- <br /> -->
          {{ $t(labelHeader("activity")) }} :
          {{ item.nameActivity != null ? item.nameActivity : "-" }} <br />
          {{ $t(labelHeader("area_operation")) }} :
          {{
            item.nameGeographicAreaOfOperation != null
              ? item.nameGeographicAreaOfOperation
              : "-"
          }}<br />
          {{ $t(labelHeader("ownership_company")) }} :
          {{
            item.nameCompanyOwnership != null ? item.nameCompanyOwnership : "-"
          }}
          <br />
          {{ $t(labelHeader("coin_type")) }} :
          {{ item.nameCoinType != null ? item.nameCoinType : "-" }} <br />
        </b-list-group-item>
        <b-list-group-item v-if="items.length == 0" class="text-center">
          {{ $t("notRegister") }}
        </b-list-group-item>
        <b-list-group-item v-if="loading">
          <b-spinner variant="success"></b-spinner>
        </b-list-group-item>
      </b-list-group>
    </div>
    <!-- pagination -->
    <div class="mx-2 d-none d-md-table">
      <b-row>
        <b-col cols="12" sm="12" md="2" lg="2" xl="2" class="mb-2">
          <b-form-group class="mb-0">
            <label class="d-inline-block text-sm-left mr-50">{{
              $t("perPage")
            }}</label>
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              @change="handlePerPageChange"
              class="w-50"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          sm="12"
          md="10"
          lg="10"
          xl="10"
          class="d-flex align-items-center justify-content-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            pills
            @change="handlePageChange"
            first-number
            last-number
          >
            <template #prev-text>
              <feather-icon size="18" icon="ChevronLeftIcon" />
            </template>
            <template #next-text>
              <feather-icon size="18" icon="ChevronRightIcon" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import _ from "lodash";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BPagination,
  BToast,
  BSpinner,
  BBadge,
  VBTooltip,
  BTooltip,
  BFormSelect,
  BAvatar,
  BFormGroup,
  BListGroup,
  BListGroupItem,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import {
  allCompaniesTypes,
  deleteCompanieType,
} from "@core/api/request/companiesTypes";
import { getParams, showLoading, stopLoading } from "@core/utils/utils";

import Filterss from "../components/filters/Filterss.vue";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BToast,
    BSpinner,
    BBadge,
    BFormSelect,
    BFormGroup,
    BTooltip,
    BAvatar,
    vSelect,
    Filterss,
    BListGroup,
    BListGroupItem,
    BDropdown,
    BDropdownItem,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data: () => ({
    loading: false,
    totalRows: null,
    currentPage: 1,
    perPage: 10,
    pageOptions: [10, 50, 100],
    hasNextPage: true,
    items: [],
    headVariant: "light",
    striped: false,
    outlined: false,
    bordered: true,
    borderless: false,
    items: [],
    fields: [
      { label: "size", key: "nameSize", sortable: true },
      { label: "activity", key: "nameActivity", sortable: true },
      {
        label: "area_operation",
        key: "nameGeographicAreaOfOperation",
        sortable: true,
      },
      {
        label: "ownership_company",
        key: "nameCompanyOwnership",
        sortable: false,
      },
      { label: "coin_type", key: "nameCoinType", sortable: false },
      { label: "action", key: "actions", sortable: false },
    ],
    fildsToFilters: [
      {
        name: "name",
        title: "nombre",
        placeholder: "nombre",
        type: "text",
        reference: "name",
        visible: true,
      },
    ],
    appliedFilters: {},

    showOptions: false,
    name: null,
    filtersOn: false,
  }),

  created() {
    this.loadCompaniesTypes();
  },

  mounted() {
    document
      .getElementById("list-container")
      .addEventListener("scroll", this.handleScroll);
  },

  methods: {
    async handleScroll() {
      const container = document.getElementById("list-container");
      // console.log("fffffff",container.scrollTop + container.clientHeight,container.scrollHeight -1)
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 1
      ) {
        this.currentPage++;
        await this.loadCompaniesTypesInfinity();
      }
    },
    label(field) {
      return `pages.typeCompanies.table.${field}`;
    },

    labelHeader(field) {
      return `pages.typeCompanies.table.tableHeader.${field}`;
    },

    chargeParams() {
      const arrParams = [];

      arrParams.push(`page,${this.currentPage}`);

      arrParams.push(`rows,${this.perPage}`);
      if (this.name != null && this.name != "")
        arrParams.push(`name,${this.name}`);
      return getParams(arrParams);
    },

    chargeParamsWithFilters(name) {
      const arrParams = [];

      arrParams.push(`page,${this.currentPage}`);

      arrParams.push(`rows,${this.perPage}`);

      arrParams.push(`name,${name}`);
      return getParams(arrParams);
    },
    loadCompaniesTypes() {
      if (!this.hasNextPage) return;
      const param = this.chargeParams();
      this.loading = !this.loading;
      allCompaniesTypes(param)
        .then((resp) => {
          const data = _.get(resp, "data");
          this.items = data?.items || [];
          this.totalRows = data?.totalRows || 0;
          this.loading = !this.loading;
          this.hasNextPage = data?.currentPage < data?.totalPages || 0;
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = !this.loading;
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },
    loadCompaniesTypesInfinity() {
      if (!this.hasNextPage) return;
      const param = this.chargeParams();
      this.loading = !this.loading;
      allCompaniesTypes(param)
        .then((resp) => {
          const data = _.get(resp, "data");
          this.items = [...this.items, ...data?.items];
          this.totalRows = data?.totalRows || 0;
          this.loading = !this.loading;
          this.hasNextPage = data?.currentPage < data?.totalPages || 0;
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = !this.loading;
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },
    loadCompaniesTypesWithFilters(name) {
      const param = this.chargeParamsWithFilters(name);
      this.loading = !this.loading;
      allCompaniesTypes(param)
        .then((resp) => {
          const data = _.get(resp, "data");
          this.items = data?.items || [];
          this.totalRows = data?.totalRows || 0;
          this.loading = !this.loading;
          if (resp.data == null) {
            this.alertToast(
              "danger",
              `Error`,
              `No se encontraron coincidencias`,
            );
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = !this.loading;
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },

    handlePageChange(value) {
      this.currentPage = value;
      this.hasNextPage = true;
      this.loadCompaniesTypes();
    },

    handlePerPageChange() {
      this.currentPage = 1;
      this.loadCompaniesTypes();
    },

    deleteCompanyType() {
      // this.alertToast('success', error.message)
      // this.alertToast('danger', error.message)

      const appLoading = document.getElementById("loading-bg");
      deleteCompanieType(this.guidDelete)
        .then((resp) => {
          // this.items = resp

          if (resp.data.data === "Transacción exitosa.") {
            this.alertToast("success", "Eliminacion Exitosa");
            this.loadCompaniesTypes();
            this.deleteComTy = false;
          }
          appLoading.style.display = "none";
        })
        .catch((error) => {
          console.log("error", error);
          this.alertToast("danger", `Alerta codigo`, error.message);
          appLoading.style.display = "none";
        });
    },

    applyFilters(filters) {
      this.appliedFilters = filters;
      this.name = filters.name;
      this.currentPage = 1;
      this.hasNextPage = true;
      this.loadCompaniesTypesWithFilters(filters.name);
    },
    resetFilters() {
      this.appliedFilters = {};
      this.currentPage = 1;
      this.hasNextPage = true;
      this.name = null;
      this.loadCompaniesTypes();
    },
    onCreate() {
      this.$router.push({
        name: "companieTypeCreate",
        params: {
          option: 1, // option 1 to create
        },
      });
    },

    onShow(guid) {
      this.$router.push({
        name: "companieTypeEdit",
        params: {
          option: 2, // option 2 to show
          guid: guid,
        },
      });
    },

    onEdit(guid) {
      this.$router.push({
        name: "companieTypeEdit",
        params: {
          option: 3, // option 3 to edit
          guid: guid,
        },
      });
    },

    onInfo() {},

    message(title, text, icon, html) {
      this.$swal({
        title,
        text,
        html,
        icon,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    },

    alertToast(type = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon: "CoffeeIcon",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.list-container {
  height: 60vh !important; /* Ajusta el alto según tus necesidades */
  overflow-y: auto;
}
</style>
